import { Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { BsTrash } from "react-icons/bs";
import { getPortales } from "../../services";

const Portales = ({ prop_id, formData, setFormData, error }) => {
    const { t } = useTranslation('common');

    const [listaPortales, setListaPortales] = useState([]);
    const [inicializado, setInicializado] = useState(false);
    const [portalesServidor, setPortalesServidor] = useState([]);
    
    useEffect(() => {
        const cargarPortales = async (id) => {
            try {
                const portales = await getPortales(id);
                setPortalesServidor(portales);
                
                if (!formData || formData.length === 0) {
                    setListaPortales(portales);
                    setFormData(prev => ({
                        ...prev,
                        portales: portales,
                    }));
                }
                setInicializado(true);
            } catch (error) {
                console.error('Error cargando portales:', error);
                setInicializado(true);
            }
        };
        
        if (prop_id && !inicializado) {
            cargarPortales(prop_id);
        }
    }, [prop_id, inicializado, formData, setFormData]);
    
    useEffect(() => {
        if (formData && Array.isArray(formData)) {
            if (formData.length > 0) {
                setListaPortales(formData);
            }
        }
    }, [formData]);

    const handleAddItem = () => {
    const portalesActivos = listaPortales.filter(p => !p.del);
    const maxNumero = portalesActivos.reduce((max, p) => {
        const num = parseInt(p.nombre, 10);
        return !isNaN(num) && num > max ? num : max;
    }, 0);
    const newItem = { nombre: String(maxNumero + 1), numEscaleras: "", numVecinos: "", isNew: true, del:false };
    setListaPortales([...listaPortales, newItem]);
    };
    
    const handleEditItem = async (index) => {
    const updatedItem = listaPortales[index];
    const updatedItems = [...listaPortales];
    updatedItems[index] = updatedItem;
    setFormData(prev => ({
        ...prev,
        portales: updatedItems,
    }));
    setListaPortales(updatedItems);
    };

    const handleRemoveItem = async (index) => {
    const removedItem = listaPortales[index];
    const updatedItems = listaPortales.filter((_, i) => i !== index);
    if(removedItem.id){
        setFormData(prev => ({
            ...prev,
            delPortales: [
                ...(prev.delPortales || []),
                { ...removedItem, del: true }
            ]
        }));
    }
    setFormData(prev => ({
        ...prev,
        portales: updatedItems,
    }));
    setListaPortales(updatedItems);
    };

    const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedItems = [...listaPortales];
    updatedItems[index][name] = value;
    handleEditItem(index);
    setListaPortales(updatedItems);
    };

    return ( 
        <>
            <div>
                {error?.portales && (
                    <div style={{ 
                        margin: '10px 0', 
                        padding: '10px', 
                        backgroundColor: '#ffebee', 
                        border: '1px solid #f44336',
                        borderRadius: '4px',
                        color: '#c62828'
                    }}>
                        <p style={{ margin: 0, fontSize: '14px' }}>
                            {error?.portales}
                        </p>
                    </div>
                )}
                {listaPortales.length === 0 ? <div style={{ margin: 15 }}><p>{t('portals.noPortals')}</p></div> :
                listaPortales
                .map((item, index) => {
                    if (item.del === true) return null;
                    const itemError = Array.isArray(error?.portalesErrors) ? error?.portalesErrors[index] || {} : {};
                    
                    return(
                        <div key={index}>
                            <Box
                                mx={1}
                                display={"flex"}
                                flexDirection={"row"}
                                alignItems={'center'}
                                // gap={2}
                            >
                                <TextField
                                    style={{ width: "50%", margin: "5px" }}
                                    type="text"
                                    label={t('portals.portal')}
                                    variant="outlined"
                                    name="nombre"
                                    onChange={(e) => handleInputChange(index, e)}
                                    InputLabelProps={{ shrink: true }}
                                    value={item.nombre}
                                    error={!!itemError.nombre}
                                    helperText={itemError.nombre ? t('portals.fieldRequired') : ""}
                                />
                                <TextField
                                    style={{ width: "50%", margin: "5px" }}
                                    type="number"
                                    label={t('portals.numStairs')}
                                    variant="outlined"
                                    name="numEscaleras"
                                    onChange={(e) => handleInputChange(index, e)}
                                    InputLabelProps={{ shrink: true }}
                                    value={item.numEscaleras}
                                    error={!!itemError.numEscaleras}
                                    helperText={itemError.numEscaleras ? t('portals.fieldRequired') : ""}
                                />
                                <TextField
                                    style={{ width: "50%", margin: "5px" }}
                                    type="number"
                                    label={t('portals.numNeighbors')}
                                    variant="outlined"
                                    name="numVecinos"
                                    onChange={(e) => handleInputChange(index, e)}
                                    InputLabelProps={{ shrink: true }}
                                    value={item.numVecinos}
                                    error={!!itemError.numVecinos}
                                    helperText={itemError.numVecinos ? t('portals.fieldRequired') : ""}
                                />
                                <div style={{display:'flex', flexWrap: 'wrap'}}>
                                    <Button onClick={() => handleRemoveItem(index)} style={{ backgroundColor:'transparent', color: "#000", height: 30, border: 'none' }}><BsTrash /></Button>
                                </div>    
                            </Box>
                        </div>
                    )
                })}
                <Box
                    mx={2}
                    my={3}
                    display={"flex"}
                    flexDirection={"row"}
                // gap={2}
                >
                    <Button className="btn-Secondary" variant="contained" style={{color:"white"}} onClick={handleAddItem}>{t('portals.addNewPortal')}</Button>
                </Box>
            </div>
        </> 
    );
}
 
export default Portales;